import { Space } from '@procurify/ui'

import { TextLoader } from '@webapp/core/components/ContentLoader'

export const SlackIntegrationSectionLoader = () => {
  return (
    <Space direction='vertical'>
      <TextLoader width={400} />
      <TextLoader width={400} />
      <TextLoader width={400} />
    </Space>
  )
}
